/**
 * @desc 根据id查询品种
 */
import { KindDetail } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryKindParameter = {
  id?: string
}

const method = 'GET'
const url = '/system/kind'

export const queryKindApi = (
  params?: QueryKindParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<KindDetail>({
    method,
    url,
    params,
    ...config
  })
}

queryKindApi.method = method
queryKindApi.url = url
